import * as io from 'io-ts';

export const nullable = (type: any) => io.union([io.null, type]);
